import Styled, { css } from 'styled-components';

import { Caption } from '../../Typography/Caption';

import ProgressTrackerHRule from './ProgressTrackerHRule';
import ProgressTrackerIndicator from './ProgressTrackerIndicator';
import ProgressTrackerStepNumber from './ProgressTrackerStepNumber';

export interface IProgressTrackerStepWrapperProps {
  outstanding?: boolean;
  currentStep?: boolean;
}

const ProgressTrackerStepWrapper = Styled.div<IProgressTrackerStepWrapperProps>`
  display: flex;
  width: ${({ theme: { progressTracker } }) => progressTracker.trackerWrapperWidth};

  &:last-of-type {
    ${ProgressTrackerHRule} {
      display: none;
    }

    width: unset;
  }

  ${({
    theme: {
      colorWhite,
      progressTracker: {
        colorHrCompleted,
        colorHrOutstanding,
        colorStepBgCompleted,
        colorStepBgOutstanding,
        colorStepBorderOutstanding,
        colorTextCompleted,
        colorTextOutstanding,
        hrHorizontalOffset,
        hrWidth,
        stepLabelFontWeight,
        stepLabelHorizontalOffset,
        stepNumberFontWeight,
        stepNumberFontSize,
        stepNumberVerticalOffset,
        trackerIndicatorWidth,
        trackerIndicatorHeight,
      },
    },
    outstanding,
    currentStep,
  }) => css`
    ${Caption} {
      margin-top: ${stepLabelHorizontalOffset};
      text-align: center;
      font-weight: ${stepLabelFontWeight};
      color:
        ${outstanding && !currentStep
          ? colorTextOutstanding
          : colorTextCompleted};
    }

    ${ProgressTrackerHRule} {
      width: ${hrWidth};
      margin-top: ${hrHorizontalOffset};
      background-color:
        ${outstanding || currentStep
          ? colorHrOutstanding
          : colorHrCompleted};
    }

    ${ProgressTrackerIndicator} {
      width: ${trackerIndicatorWidth};
      height: ${trackerIndicatorHeight};
      background-color: ${outstanding ? colorStepBgOutstanding : colorStepBgCompleted};
      ${outstanding && `border: 2px solid ${colorStepBorderOutstanding};`}
      ${currentStep && `background-color: ${colorStepBgCompleted}; border: none;`}
    }

    ${ProgressTrackerStepNumber} {
      margin-top: ${stepNumberVerticalOffset};
      font-weight: ${stepNumberFontWeight};
      font-size: ${stepNumberFontSize};
      color: ${outstanding ? colorTextOutstanding : colorWhite};
      ${currentStep && `color: ${colorWhite};`}
    }
  `}
`;

export default ProgressTrackerStepWrapper;
